import axios from 'axios';
import { useEffect, useState } from 'react';
import { FocusTrap } from 'focus-trap-react';
import { useIs17Inch } from '../../../hooks/useBreakPoint';

import '../../../css/modal.css'

const RegisterModal = ({ isModalOpen, modalClose, updateParams }) => {

    const getByteLength = (str) => {
        if (!str) return 0;
        return str.replace(/[\0-\x7f]|([0-߿]|(.))/g, '$&$2').length;
    };
    const isDmsHtelFormat = (val) => /^(02|0[3-9][0-9])-?[0-9]{3,4}-?[0-9]{4}$/.test(val || '');
    const isDmsMobiletelFormat = (val) => /^01[016789]-?[0-9]{3,4}-?[0-9]{4}$/.test(val || '');
    const isEmail = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val || '');

    // 추천하는 초기화 방식
    const [telList, setTelList] = useState({
        telInfo: {},
        urdbTypeList: [],
        urdbLiccdList: [],
        urdbHircdList: [],
        urdbWokcdList: []
    });

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;

        setTelList((prev) => ({
            ...prev,
            telInfo: {
                ...prev.telInfo,
                [name]: type === 'checkbox' ? (checked ? 'Y' : 'N') : value,
            },
        }));
    };

    const handleClose = () => {
        setTelList({
            telInfo: {},
            urdbTypeList: [],
            urdbLiccdList: [],
            urdbHircdList: [],
            urdbWokcdList: []
        });
        modalClose();
    };

    const fetchInitialData = async () => {
        try {
            const response = await axios.get('/commonapi/agent/get_telinfo.do', {
                params: {
                    urdbemcd: updateParams.urdbemcd,
                    urdbtype: updateParams.urdbtype,
                    urdbseqn: updateParams.urdbseqn,
                }
            });
            console.log(response.data);
            setTelList(response.data);
        } catch (error) {
            console.error('초기 데이터 로딩 중 오류 발생:', error);
        }
    };

    const saveTel = async () => {
        const data = telList.telInfo || {};

        const requiredFields = [
            { key: 'urdbtype', msg: '업무구분' },
            { key: 'urdbname', msg: '성명' },
            { key: 'urdbdept', msg: '부서' },
            { key: 'urdbtel1', msg: '연락처' },
            { key: 'urdbcell', msg: '핸드폰' },
        ];
        if (data.urdbsmtm === 'Y' && data.urdbtype === '정보관리자') {
            requiredFields.push({ key: 'urdbliccd', msg: '면허또는자격' });
        }

        for (const field of requiredFields) {
            if (!data[field.key] || String(data[field.key]).trim() === '') {
                alert(`${field.msg}은(는) 필수사항입니다.`);
                return false;
            }
        }
        const lengthCheckFields = [
            { key: 'urdbname', title: '성명', maxLength: 20 },
            { key: 'urdbdept', title: '부서', maxLength: 50 },
            { key: 'urdbgrde', title: '직위', maxLength: 20 },
            { key: 'urdbtel1', title: '연락처', maxLength: 13 },
            { key: 'urdbtel2', title: 'EDUP ID', maxLength: 15 },
            { key: 'urdbcell', title: '휴대폰번호', maxLength: 13 },
            { key: 'urdbmail', title: '이메일', maxLength: 30 },
            { key: 'urdbfaxx', title: '팩스번호', maxLength: 13 },
            { key: 'urdbwoktm', title: '근무시간', maxLength: 500 },
        ];
        for (const field of lengthCheckFields) {
            const val = data[field.key];
            if (val) {
                const byteLen = getByteLength(val);
                if (byteLen > field.maxLength) {
                    alert(`${field.title} 이/가 사이즈가 초과됩니다. ${byteLen}/${field.maxLength}`);
                    return false;
                }
            }
        }
        if (!isDmsHtelFormat(data.urdbtel1)) {
            alert('지역번호를 포함한 연락처를 정확히 입력해주세요.');
            return false;
        }

        if (!isDmsMobiletelFormat(data.urdbcell)) {
            alert('핸드폰 번호를 정확히 입력해주세요.');
            return false;
        }

        if (data.urdbmail && data.urdbmail.trim() !== '') {
            if (!isEmail(data.urdbmail)) {
                alert('이메일을 정확히 입력해주세요.');
                return false;
            }
        }
        if (data.urdbhtln === 'Y') {
            if (!data.urdbwkstdt || data.urdbwkstdt === '' || data.urdbwkstdt === '0000-00-00') {
                alert('업무시작일을 입력해주세요.');
                return false;
            }
            if (data.urdbwkendt && data.urdbwkendt !== '' && data.urdbwkendt !== '0000-00-00') {
                if (data.urdbwkendt < data.urdbwkstdt) {
                    alert('업무종료일은 업무시작일 이전일 수 없습니다.');
                    return false;
                } else {
                    alert('업무종료일은 삭제에만 입력 가능합니다.');
                    return false;
                }
            }
        }
        try {
            const sendData = {
                ...telList.telInfo,
            };

            const params = new URLSearchParams();
            Object.keys(sendData).forEach(key => {
                if (sendData[key] !== null && sendData[key] !== undefined) {
                    params.append(key, sendData[key]);
                }
            });
            console.log(Object.fromEntries(params));
            const response = await axios.post('/commonapi/agent/save_telinfo.do', params, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            });
            const responseData = typeof response.data === 'string'
                ? JSON.parse(response.data)
                : response.data;

            if (responseData.correct) {
                alert(responseData.resultMessage);
                // handleClose();
            } else {
                alert(responseData.resultMessage);
            }
        } catch (error) {
            console.error('저장 중 오류 발생:', error);
            alert('저장 처리 중 오류가 발생했습니다.');
        }
    };

    const deleteTel = async () => {
        const startDate = new Date(telList.telInfo?.urdbwkstdt);
        const endDate = new Date(telList.telInfo?.urdbwkendt);

        console.log(telList.telInfo?.urdbcell);
        if (telList.telInfo?.urdbseqn == '') {
            alert('삭제할 연락처를 선택해주세요.');
            return false;
        } else if (!window.confirm('해당 연락처를 삭제하시겠습니까?')) {
            return false;
        };

        if (telList.telInfo?.urdbhtln == 'Y') {
            if (telList.telInfo?.urdbwkendt == undefined || telList.telInfo?.urdbwkendt == '' || telList.telInfo?.urdbwkendt == '0000-00-00') {
                alert('업무종료일을 입력해주세요.');
                return false;
            } else if (telList.telInfo?.urdbwkendt != undefined && telList.telInfo?.urdbwkendt != '' && telList.telInfo?.urdbwkendt != '0000-00-00' && endDate < startDate) {
                alert('업무종료일은 업무시작일 이전일 수 없습니다.');
                return false;
            }
        };

        try {
            const response = await axios.post('/commonapi/agent/delete_telinfo.do', {
                params: {
                    urdbemcd: updateParams.urdbemcd,
                    urdbwkendt: telList.telInfo?.urdbwkendt,
                    urdbseqn: updateParams.urdbseqn,
                }
            });
            const responseData = typeof response.data === 'string'
                ? JSON.parse(response.data)
                : response.data;
            if (responseData.correct) {
                alert(responseData.resultMessage);
                handleClose();
            } else {
                alert(responseData.resultMessage);
            }

        } catch (error) {
            console.error('삭제 요청 중 오류 발생:', error);
            alert('서버 통신 중 문제가 발생했습니다.');
        }
    }

    useEffect(() => {
        if (isModalOpen.modalState && updateParams.urdbemcd) {
            fetchInitialData();
        }
    }, [isModalOpen.modalState, updateParams.urdbemcd, updateParams.urdbseqn]);

    // esc 키 누르면 모달 닫히는 기능
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') handleClose();
        };

        // 이벤트 리스너 등록
        document.addEventListener('keydown', handleEscape);

        // 컴포넌트가 언마운트될 때 이벤트 리스너 제거
        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [modalClose]);

    const is17Inch = useIs17Inch();

    // 면허또는자격 필수 여부(중증질환담당 + 정보관리자)
    const isLiccdRequired = telList.telInfo?.urdbsmtm === 'Y' && telList.telInfo?.urdbtype === '정보관리자';

    return (
        <>
            {isModalOpen.modalState &&
                <FocusTrap>
                    <div className='layer_container'>
                        <div className='layer_wrapper' style={{ maxWidth: '56rem' }}>
                            <div className={`modal_title_box ${is17Inch ? 'mb-1' : 'mb-2'}`}>
                                <h4>연락처 {updateParams.urdbseqn === '' ? '등록' : '상세보기'}</h4>
                            </div>
                            <hr />
                            <div className='overflow-y-auto' style={{ maxHeight: is17Inch ? '20rem' : '32rem' }}>
                                <div className='com-search'>
                                    <table>
                                        <colgroup>
                                            <col width='16%' />
                                            <col width='34%' />
                                            <col width='16%' />
                                            <col width='34%' />
                                        </colgroup>
                                        <tbody key={updateParams.urdbseqn || 'new-record'}>
                                            <tr>
                                                <th>담당구분</th>
                                                <td colSpan='3'>
                                                    <div className='flex flex-wrap items-center gap-4'>
                                                        <div className='flex items-center gap-1'>
                                                            <input type='checkbox' id='urdbedis' name='urdbedis' value='Y' defaultChecked={telList.telInfo?.urdbedis === 'Y'} onChange={handleInputChange} />
                                                            <label htmlFor='urdbedis'>표준등록체계</label>
                                                        </div>
                                                        <div className='flex items-center gap-1'>
                                                            <input type='checkbox' id='urdbstrm' name='urdbstrm' value='Y' defaultChecked={telList.telInfo?.urdbstrm === 'Y'} onChange={handleInputChange} />
                                                            <label htmlFor='urdbstrm'>외상등록체계</label>
                                                        </div>
                                                        <div className='flex items-center gap-1'>
                                                            <input type='checkbox' id='urdbsmtm' name='urdbsmtm' value='Y' defaultChecked={telList.telInfo?.urdbsmtm === 'Y'} onChange={handleInputChange} />
                                                            <label htmlFor='urdbsmtm'>중증질환담당</label>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>기관명</th>
                                                <td id='telinfo_emogdesc'>{telList.telInfo?.emogdesc || '-'}</td>
                                                <th><span className='co_red'>*</span> 업무구분</th>
                                                <td>
                                                    <input type='hidden' name='urdbtypeOld' value={telList.telInfo?.urdbtype || ''} />
                                                    <select id='telinfo_urdbtype' name='urdbtype' title='업무구분' defaultValue={telList.telInfo?.urdbtype || ''} onChange={handleInputChange}>
                                                        <option value=''>선택</option>
                                                        {telList.urdbTypeList?.map((item, idx) => (
                                                            <option key={idx} value={item.bscddesc}>{item.bscddesc}</option>
                                                        ))}
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th><span className='co_red'>*</span> 성명</th>
                                                <td colSpan='3'>
                                                    <div className='flex flex-wrap items-center gap-4'>
                                                        <input type='text' id='telinfo_urdbname' name='urdbname' className='input_style' title='성명' defaultValue={telList.telInfo?.urdbname || ''} readOnly={telList.mode === 'modify'} maxLength='20' onChange={handleInputChange} />
                                                        <div className='flex items-center gap-1'>
                                                            <input type='checkbox' id='telinfo_urdbsdma' name='urdbsdma' value='Y' defaultChecked={!telList.telInfo || telList.telInfo.urdbsdma === 'Y'} onChange={handleInputChange} />
                                                            <label htmlFor='telinfo_urdbsdma'>알림 수신 동의</label>
                                                        </div>
                                                        <span id='telinfo_hidden' className='co_gray text-sm'>※ 정보확인자는 진료가능조회 화면에서 정보확인자 등록시 문자 발송</span>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th><span className='co_red'>*</span> 근무부서</th>
                                                <td>
                                                    <input type='text' id='telinfo_urdbdept' name='urdbdept' className='input_style w-full' title='부서' defaultValue={telList.telInfo?.urdbdept || ''} maxLength='50' onChange={handleInputChange} />
                                                </td>
                                                <th>직위</th>
                                                <td>
                                                    <input type='text' id='telinfo_urdbgrde' name='urdbgrde' className='input_style w-full' title='직위' defaultValue={telList.telInfo?.urdbgrde || ''} maxLength='20' onChange={handleInputChange} />
                                                </td>
                                            </tr>
                                            <tr>
                                                <th><span className='co_red'>*</span> 연락처</th>
                                                <td>
                                                    <input type='text' id='telinfo_urdbtel1' name='urdbtel1' className='input_style w-full' title='연락처' defaultValue={telList.telInfo?.urdbtel1 || ''} maxLength='13' onChange={handleInputChange} />
                                                </td>
                                                <th>EDUP ID</th>
                                                <td>
                                                    <input type='text' id='telinfo_urdbtel2' name='urdbtel2' className='input_style w-full' title='EDUP ID' defaultValue={telList.telInfo?.urdbtel2 || ''} maxLength='15' onChange={handleInputChange} />
                                                </td>
                                            </tr>
                                            <tr>
                                                <th><span className='co_red'>*</span> 핸드폰</th>
                                                <td>
                                                    <input type='text' id='telinfo_urdbcell' name='urdbcell' className='input_style w-full' title='휴대폰번호' defaultValue={telList.telInfo?.urdbcell || ''} maxLength='13' onChange={handleInputChange} />
                                                </td>
                                                <th>이메일</th>
                                                <td>
                                                    <input type='text' id='telinfo_urdbmail' name='urdbmail' className='input_style w-full' title='이메일' defaultValue={telList.telInfo?.urdbmail || ''} maxLength='30' onChange={handleInputChange} />
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>팩스</th>
                                                <td>
                                                    <input type='text' id='telinfo_urdbfaxx' name='urdbfaxx' className='input_style w-full' title='팩스번호' defaultValue={telList.telInfo?.urdbfaxx || ''} maxLength='13' onChange={handleInputChange} />
                                                </td>
                                                <th>
                                                    {isLiccdRequired && <span id='smtm_req' className='co_red'>*</span>} 면허또는자격
                                                </th>
                                                <td>
                                                    <select id='telinfo_urdbliccd' name='urdbliccd' disabled={!isLiccdRequired} title='면허또는자격' defaultValue={telList.telInfo?.urdbliccd || ''} onChange={handleInputChange}>
                                                        <option value=''>선택</option>
                                                        {telList.urdbLiccdList?.map((item, idx) => (
                                                            <option key={idx} value={item.bscdminr}>{item.bscddesc}</option>
                                                        ))}
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>고용형태</th>
                                                <td>
                                                    <select id='telinfo_urdbhircd' name='urdbhircd' title='고용형태' defaultValue={telList.telInfo?.urdbhircd || ''} onChange={handleInputChange}>
                                                        <option value=''>선택</option>
                                                        {telList.urdbHircdList?.map((item, idx) => (
                                                            <option key={idx} value={item.bscdminr}>{item.bscddesc}</option>
                                                        ))}
                                                    </select>
                                                </td>
                                                <th>근무형태</th>
                                                <td>
                                                    <select id='telinfo_urdbwokcd' name='urdbwokcd' title='근무형태' defaultValue={telList.telInfo?.urdbwokcd || ''} onChange={handleInputChange}>
                                                        <option value=''>선택</option>
                                                        {telList.urdbWokcdList?.map((item, idx) => (
                                                            <option key={idx} value={item.bscdminr}>{item.bscddesc}</option>
                                                        ))}
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>근무시간</th>
                                                <td colSpan='3'>
                                                    <input type='text' id='telinfo_urdbwoktm' name='urdbwoktm' className='input_style w-full' title='근무시간' defaultValue={telList.telInfo?.urdbwoktm || ''} maxLength='500' onChange={handleInputChange} />
                                                </td>
                                            </tr>
                                            {telList.telInfo?.urdbhtln == 'Y' &&
                                                <tr className='hotline_workdt'>
                                                    <th><span className='co_red'>*</span> 업무시작일</th>
                                                    <td>
                                                        <input type='date' id='telinfo_urdbwkstdt' name='urdbwkstdt' className='input_style' title='업무시작일' defaultValue={telList.telInfo?.urdbwkstdt || ''} onChange={handleInputChange} />
                                                    </td>
                                                    <th><span className='co_red'>*</span> 업무종료일</th>
                                                    <td>
                                                        <input type='date' id='telinfo_urdbwkendt' name='urdbwkendt' className='input_style' title='업무종료일' defaultValue={telList.telInfo?.urdbwkendt || ''} min={telList.telInfo?.urdbwkstdt || ''} onChange={handleInputChange} />
                                                    </td>
                                                </tr>
                                            }
                                            <tr>
                                                <th>메모</th>
                                                <td colSpan='3'>
                                                    <textarea rows='3' id='telinfo_urdbmemo' name='urdbmemo' className='textarea_style resize-none' defaultValue={telList.telInfo?.urdbmemo || ''} onChange={handleInputChange}></textarea>
                                                </td>
                                            </tr>
                                            {telList.telInfo?.urdbwkdt && (
                                                <tr>
                                                    <th>수정일</th>
                                                    <td colSpan='3'>
                                                        {telList.telInfo.urdbwkdt}&nbsp;{telList.telInfo.urdbwktm}
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                {telList.telInfo?.urdbhtln == 'Y' &&
                                    <div className='hotline_notify mt-1 text-left'>
                                        <p className='co_red bold'>※ 전원전담코디네이터: 저장 시 '업무시작일' 입력 후 저장 필요</p>
                                        <p className='co_red bold ml-32 pl-1'>삭제 시 '업무종료일' 입력 후 삭제 필요</p>
                                    </div>
                                }
                            </div>
                            <hr />
                            <div className='modal_btn_box'>
                                <button className='modal_btn bg_ho_primary' onClick={saveTel}>저장</button>
                                {updateParams.urdbseqn === '' ? '' : <button className='modal_btn bg_tr_primary' onClick={deleteTel}>삭제</button>}
                                <button className='modal_btn bg_co_black' onClick={handleClose}>닫기</button>
                            </div>
                        </div>
                    </div>
                </FocusTrap>
            }
        </>
    )
}
export default RegisterModal
